import _ from '@lodash';

export const handleChangeTab = setTabValue => (event, value) => {
  setTabValue(value);
};

const requiredFieldsNotEmpty = (form, requiredFields) => {
  return (
    !requiredFields ||
    !requiredFields.some(field => {
      if (typeof form[field] === 'string') {
        return form[field].trim() === '';
      }
      if (typeof form[field] === 'number') {
        return false;
      }
      if (Array.isArray(form[field])) {
        return form[field].length === 0;
      }
      // all other types are invalid at the moment
      return true;
    })
  );
};

export const canBeSubmitted = (form, entity, requiredFields = ['name']) => {
  return requiredFieldsNotEmpty(form, requiredFields) && !_.isEqual(entity, form);
};

export const needToShowLoading = (entity, paramId) => {
  return (!entity || (entity && entity.id && paramId.toString() !== entity.id.toString())) && paramId !== 'new';
};
